import { API_ENDPOINT } from "@/constants/appConstants";
import { useProfileSectionData } from "@/hooks";
import {
  AI_SUMMARY,
  PROFILE_QUERY_KEY,
  PROFILE_STATS_QUERY_KEY,
  VALIDATE_PROFILE_QUERY_KEY,
} from "@/lib/queryKeys";
import { encryptPayload } from "@/utils/encryptionUtils";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { ErrorResponse } from "@/components/profile/types";

import { PersonalDetailsAPIResponse } from "./types";

// export const getPersonalDetails = (): UseQueryResult<
//   PersonalDetailsAPIResponse,
//   Error
// > => {
//   return useQuery({
//     queryKey: [PERSONAL_QUERY_KEY],
//     queryFn: () => profileAPI<PersonalDetailsAPIResponse>("personal_details"),
//   });
// };

export const getPersonalDetails = () => {
  return useProfileSectionData<PersonalDetailsAPIResponse>(
    "personalDetailSection",
  );
};

export const useSaveContact = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: any) => {
      const response = await fetch(
        API_ENDPOINT(window.location.host).middleware.saveContact,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
          credentials: "include",
        },
      );

      if (!response.ok) {
        const errorData = (await response.json()) as ErrorResponse;
        throw new Error(
          errorData.error.message.errorMessage || "Something went wrong",
        );
      }

      return await response.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [PROFILE_QUERY_KEY] });
      queryClient.invalidateQueries({ queryKey: [PROFILE_STATS_QUERY_KEY] });
    },
  });
};

export const useSendMobileOTP = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: any) => {
      const encryptedPayload = encryptPayload(data);
      const response = await fetch(
        API_ENDPOINT(window.location.host).middleware.sendMobileOTP,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ payload: encryptedPayload }),
          credentials: "include",
        },
      );

      if (!response.ok) {
        const errorData = (await response.json()) as ErrorResponse;
        throw new Error(
          errorData.error.message.errorMessage || "Something went wrong",
        );
      }

      return await response.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [PROFILE_QUERY_KEY] });
      // queryClient.invalidateQueries({ queryKey: [PERSONAL_QUERY_KEY] });
    },
  });
};

export const useVerifyMobileOTP = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: any) => {
      const response = await fetch(
        API_ENDPOINT(window.location.host).middleware.verifyMobileOTP,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
          credentials: "include",
        },
      );

      if (!response.ok) {
        const errorData = (await response.json()) as ErrorResponse;
        throw new Error(
          errorData.error.message.errorMessage || "Something went wrong",
        );
      }

      return await response.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [PROFILE_QUERY_KEY] });
      // queryClient.invalidateQueries({ queryKey: [PERSONAL_QUERY_KEY] });
      // for updating the profile score
      queryClient.invalidateQueries({ queryKey: [PROFILE_STATS_QUERY_KEY] });
      // for updating the l1 apop action_type
      queryClient.invalidateQueries({ queryKey: [VALIDATE_PROFILE_QUERY_KEY] });
      // to update ai summary
      queryClient.invalidateQueries({ queryKey: [AI_SUMMARY] });
    },
  });
};

export const useSendEmailOTP = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: any) => {
      const response = await fetch(
        API_ENDPOINT(window.location.host).middleware.sendEmailOTP,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
          credentials: "include",
        },
      );

      if (!response.ok) {
        const errorData = (await response.json()) as ErrorResponse;
        throw new Error(
          errorData.error.message.errorMessage || "Something went wrong",
        );
      }

      return await response.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [PROFILE_QUERY_KEY] });
      // queryClient.invalidateQueries({ queryKey: [PERSONAL_QUERY_KEY] });
    },
  });
};

export const useVerifyEmailOTP = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: any) => {
      const response = await fetch(
        API_ENDPOINT(window.location.host).middleware.verifyEmailOTP,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
          credentials: "include",
        },
      );

      if (!response.ok) {
        const errorData = (await response.json()) as ErrorResponse;
        throw new Error(
          errorData.error.message.errorMessage || "Something went wrong",
        );
      }

      return await response.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [PROFILE_QUERY_KEY] });
      // queryClient.invalidateQueries({ queryKey: [PERSONAL_QUERY_KEY] });
      // for updating the profile score
      queryClient.invalidateQueries({ queryKey: [PROFILE_STATS_QUERY_KEY] });
      // for updating the l1 apop action_type
      queryClient.invalidateQueries({ queryKey: [VALIDATE_PROFILE_QUERY_KEY] });
      // to update ai summary
      queryClient.invalidateQueries({ queryKey: [AI_SUMMARY] });
    },
  });
};
